/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { FC } from 'react';

import { ReadSMSAction } from '@/commons/data';

export const LastReadSMS: FC<{
    readSMSAction: ReadSMSAction;
}> = function ({ readSMSAction }) {
    const message = readSMSAction.smsMessage;

    return (
        message && (
            <div
                className={'truncate'}
                title={'Click to copy the HTML contents into clipboard'}
                onClick={() => navigator.clipboard.writeText(message.body)}
            >
                Last SMS read from {message.from} ({new Date(message.date).toString()}): {message.body}
            </div>
        )
    );
};
